import type { ReactNode } from "react";
import { PublicFooter, PublicHeader } from "@/components/public-layout";

export function MarketingPageShell({ children }: { children: ReactNode }) {
	return (
		<div className="flex min-h-svh flex-col bg-background text-foreground">
			<PublicHeader />
			<main className="relative z-10 flex-1">
				<div className="mx-auto max-w-6xl px-4 sm:px-6">
					<div className="marketing-line-stack flex flex-col overflow-hidden divide-y divide-border">
						{children}
					</div>
				</div>
			</main>
			<PublicFooter />
		</div>
	);
}
